import { whatsappNumbers } from './mock';

const NETWORK_LINE = 'Trabajamos junto a nuestra red de colaboración profesional especializada.';

export const practiceAreas = {
  familia: {
    team: ['paula'],
    motivo: 'Familia',
    slug: 'familia',
    label: 'Familia',
    h1: 'Abogadas de familia',
    subtitle: 'Divorcios, Alimentos, Cuidado Personal, Comunicación con los hijos y Filiaciones',
    intro: 'Atravesar una separación es difícil. Te acompañamos a resolver convenios reguladores, planes de parentalidad, reclamación o actualización de cuotas alimentarias y filiaciones de manera ágil, priorizando el bienestar de los niños.',
    metaTitle: 'Abogadas de familia en San Justo | Sampellegrini & Jaliff',
    metaDescription: 'Abogadas de familia en San Justo: divorcios, cuota alimentaria, cuidado personal, régimen de comunicación y filiaciones. Trato humano y cercano. Consultá por WhatsApp.',
    waPhone: whatsappNumbers.primary,
    waMessage: 'Hola, quiero hacer una consulta de familia',
    faqs: [
      {
        question: '¿Puedo iniciar un divorcio aunque la otra persona no esté de acuerdo?',
        answer: 'Sí. En Argentina el divorcio puede solicitarse por una sola de las partes, sin necesidad de explicar los motivos. En la consulta analizamos tu situación y te orientamos sobre cómo presentar la propuesta de convenio regulador.'
      },
      {
        question: '¿Cómo se determina la cuota alimentaria?',
        answer: 'Se tienen en cuenta las necesidades de los hijos y las posibilidades económicas de quienes deben aportar. No hay un monto fijo: cada caso se evalúa de manera particular.'
      },
      {
        question: '¿Se puede modificar un acuerdo de alimentos o de cuidado personal ya firmado?',
        answer: 'Cuando las circunstancias cambian, es posible pedir su revisión. En la consulta evaluamos si tu situación permite solicitar una modificación y cuál es el camino adecuado.'
      }
    ]
  },
  sucesiones: {
    team: ['paula', 'julieta'],
    motivo: 'Sucesiones',
    slug: 'sucesiones',
    label: 'Sucesiones',
    h1: 'Abogadas en sucesiones',
    subtitle: 'Procesos sucesorios e inscripciones por tracto abreviado',
    intro: 'Protegemos lo que te costó una vida construir. Llevamos adelante procesos sucesorios e inscripciones por tracto abreviado con la mayor rapidez posible, ayudándote a regularizar tus bienes familiares de forma eficiente y sin trámites eternos.',
    metaTitle: 'Abogadas en sucesiones en San Justo | Sampellegrini & Jaliff',
    metaDescription: 'Abogadas en sucesiones en San Justo: procesos sucesorios e inscripciones por tracto abreviado. Te explicamos cada paso con claridad. Consultá por WhatsApp.',
    waPhone: whatsappNumbers.secondary,
    waMessage: 'Hola, quiero hacer una consulta de sucesiones',
    faqs: [
      {
        question: '¿Cuándo conviene iniciar una sucesión?',
        answer: 'No hay un único momento obligatorio, pero postergarla puede dificultar la venta o disposición de los bienes. En la consulta te orientamos sobre lo más conveniente según tu situación familiar.'
      },
      {
        question: '¿Qué documentación se necesita para empezar?',
        answer: 'En general, la partida de defunción, las partidas que acreditan el vínculo con la persona fallecida, los DNI y la documentación de los bienes. Si te falta algo, te indicamos cómo obtenerlo.'
      },
      {
        question: '¿Qué pasa si los herederos no se ponen de acuerdo?',
        answer: 'Primero buscamos el diálogo y una solución consensuada. Si no es posible, el trámite continúa por la vía judicial correspondiente. Cada situación se analiza en particular.'
      }
    ]
  },
  laboral: {
    team: ['julieta'],
    motivo: 'Laboral / ART',
    slug: 'laboral',
    label: 'Laboral y ART',
    h1: 'Abogados laborales y ART',
    subtitle: 'Despidos, Indemnizaciones y Reclamos ante ART',
    intro: 'Si sufriste un despido injustificado, trabajás de forma no registrada (en negro) o tenés diferencias salariales, defendemos tus derechos. Buscamos el reclamo correspondiente para que recibas la indemnización justa. También realizamos reclamos ante ART por accidentes y enfermedades laborales.',
    network: NETWORK_LINE,
    metaTitle: 'Abogados laborales y ART en San Justo | Sampellegrini & Jaliff',
    metaDescription: 'Abogados laborales y ART en San Justo: despidos, trabajo no registrado, diferencias salariales y reclamos por accidentes y enfermedades laborales. Consultá por WhatsApp.',
    waPhone: whatsappNumbers.secondary,
    waMessage: 'Hola, quiero hacer una consulta laboral',
    faqs: [
      {
        question: 'Me despidieron, ¿qué tengo que hacer?',
        answer: 'Guardá los telegramas o cartas documento, tus recibos de sueldo y cualquier comunicación con tu empleador. Te recomendamos no firmar nada sin asesorarte antes. En la consulta analizamos qué podría corresponderte.'
      },
      {
        question: '¿Puedo reclamar si trabajé sin estar registrado (en negro)?',
        answer: 'La ley prevé la posibilidad de reclamar en estos casos. La viabilidad depende de cada situación y de las pruebas disponibles, por eso es importante evaluarlo en una consulta.'
      },
      {
        question: 'Tuve un accidente de trabajo, ¿cómo intervengo frente a la ART?',
        answer: 'Es importante que el accidente quede denunciado y que conserves toda la documentación médica. Si no estás de acuerdo con la atención, el alta o el porcentaje de incapacidad, puede haber vías de reclamo. Te asesoramos según tu caso.'
      }
    ]
  },
  'accidentes-de-transito': {
    team: ['julieta'],
    motivo: 'Accidente de tránsito',
    slug: 'accidentes-de-transito',
    label: 'Accidentes de tránsito',
    h1: 'Accidentes de tránsito y reclamos a aseguradoras',
    subtitle: 'Siniestros Viales y Reclamos a Aseguradoras',
    intro: 'Si tuviste un choque o un accidente en la vía pública o in itinere, nos encargamos de la negociación con las compañías de seguros para que obtengas el resarcimiento económico que te corresponde por los daños sufridos.',
    network: NETWORK_LINE,
    metaTitle: 'Accidentes de tránsito y reclamos a aseguradoras en San Justo | Sampellegrini & Jaliff',
    metaDescription: 'Abogadas en San Justo para accidentes de tránsito y reclamos a aseguradoras: choques, accidentes en la vía pública e in itinere. Consultá por WhatsApp.',
    waPhone: whatsappNumbers.secondary,
    waMessage: 'Hola, quiero hacer una consulta por un accidente de tránsito',
    faqs: [
      {
        question: '¿Qué conviene hacer después de un choque?',
        answer: 'Si es posible, tomá los datos del otro conductor y de su seguro, sacá fotos del lugar y de los daños, anotá datos de testigos y hacé la denuncia ante tu aseguradora. Si hubo lesiones, es importante recibir atención médica y conservar las constancias.'
      },
      {
        question: '¿Puedo reclamar si era peatón, pasajero o iba en bicicleta?',
        answer: 'Puede corresponderte un reclamo también en esos casos. Depende de cómo ocurrió el hecho y de la documentación disponible, por eso lo analizamos en la consulta.'
      },
      {
        question: '¿Hay un plazo para iniciar el reclamo?',
        answer: 'Sí, existen plazos legales que varían según el caso. Por eso es recomendable consultar cuanto antes, así podemos revisar tu situación y orientarte a tiempo.'
      }
    ]
  }
};
